import React from 'react';
import { Link } from 'react-router-dom';

function TravelAdvisories() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .advisories-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          International Medical Travel Advisory for Delhi NCR: Private Logistics & Planning Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Organizing international travel for specialized healthcare requires meticulous logistical mapping that extends past choosing a clinical consultant. For patients journeying to the Delhi National Capital Region (NCR)—encompassing New Delhi, Gurgaon, and Noida—for critical treatments, proper pre-flight scheduling reduces physical stress and protects clinical outcomes. 
          This comprehensive advisory manual details **flight selection parameters, seasonal weather considerations, local private transport safety, and regulatory data workflows** required to execute your medical trip successfully.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By tracking these operational details on independent research directories like <strong>Medical Trip World</strong>, international patient families can organize their travel timelines safely.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Download Free Pre-Travel Logistics Checklists & Templates →
        </Link>
      </div>

      {/* SECTION 1: FLIGHT & ARRIVAL LOGISTICS */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Flight Configurations and Arrival Protocols at IGI Airport
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          The primary gateway into the capital region is the Indira Gandhi International Airport (DEL) in New Delhi. This expansive multi-terminal hub is fully equipped with dedicated medical infrastructure to facilitate a smooth transfer for inbound international patients.
        </p>
        <p style={{ color: '#555', lineHeight: '1.7', margin: 0, fontSize: '0.95rem' }}>
          Standard global travel advisories suggest that families prioritize direct, non-stop long-haul flights whenever possible to avoid stressful layovers that can fatigue fragile pre-operative or post-operative patients. When cross-referencing your arrival options, ensure you request airport wheel-chair assistance or dedicated medical passenger clearances directly from your airline provider at least 48 hours before boarding.
        </p>
      </section>

      {/* SECTION 2: STRUCTURAL PRE-TRAVEL CHECKLIST */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Mandatory Pre-Flight Logistical Checklist
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          When organizing your medical itinerary, standard international patient guidelines emphasize packing and preparing the following core data segments:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Required Medical Travel Document Profile:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>Official Hospital Invitation Letter (VIL):</strong> A formal, stamped letter from your selected private facility detailing your identity, condition, and treatment timeline. This file is mandatory for border control entry processing.</li>
            <li style={{ marginBottom: '8px' }}><strong>Hard Copies of Universal Diagnostics:</strong> Carry physical duplicates or specialized universal DICOM CDs containing your latest high-resolution MRI, CT, or angioplasty scans alongside translated health summaries.</li>
            <li style={{ marginBottom: '8px' }}><strong>Regulated Pharmaceutical Stocks:</strong> Maintain a clear 14-day baseline of all current prescriptions, stored in their original packaging accompanied by a signed doctor's letter to pass through customs smoothly.</li>
            <li style={{ marginBottom: '0' }}><strong>Multi-Currency Financial Allocations:</strong> Secure certified bank records, cross-border wire documentation, or global credit options to manage your private hospital payments without banking delays.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: LOCAL TRANSIT & SEASONAL WEATHERS - RESPONSIVE MULTI-CARD */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Navigating Local Transit and Seasonal Variations Safely
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World operates exclusively as an open informational venue and independent index, we remind traveling families to follow structured protocols when organizing local commuting:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Private Hospital Transit Channels</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Confirm whether your private facility's international desk manages a dedicated airport pickup service using climate-controlled vehicles or specialized non-emergency ambulance transport to bypass local traffic stress.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Seasonal Climate Planning</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Factor regional weather blocks into your recovery windows. The intense summer heat (April to June) and high humidity winter blocks require organizing specialized indoor recovery environments.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Travel & Flight Logistics
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Can an international patient travel on a standard tourist visa for surgery?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Sovereign laws dictate that foreign citizens entering the country for purposeful medical care must secure a proper electronic Medical Visa (e-Medical Visa). Admitting an international patient for major surgical procedures under a standard tourist visa is illegal and violates local private hospital regulations.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>How do international travelers register their physical presence locally?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            All international health travelers must register with the Foreign Regional Registration Office (FRRO) within 14 days of landing. Premium private multi-specialty international wings process this mandatory paperwork sequence digitally on behalf of the patient and their attendants.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World arrange airline tickets or coordinate hotel check-ins?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World functions exclusively as an independent informational directory and research portal. We do not operate travel assets, issue airline bookings, manage local lodging, or maintain formal corporate partnerships or Memorandums of Understanding (MOUs) with any private hospital system. All financial contracts, clinical evaluations, and logistical travel arrangements happen directly and solely between the consumer and their independently selected provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="advisories-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="advisories-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default TravelAdvisories;